import { useEffect, useState } from 'react'
import FetchStatus from './FetchStatus'

const jsonResponse = /application\/json/

function fetchPageData<DataType>(
  pathname: string
): [DataType | undefined, FetchStatus, string | undefined] {
  const [fetchStatus, setFetchStatus] = useState(FetchStatus.Initial)
  const dataPath = `/cms-data/${pathname}.json`
  const [data, setData] = useState<DataType>()
  const [error, setError] = useState<string>()
  useEffect(() => {
    setFetchStatus(FetchStatus.Fetching)
    setError(undefined)
    fetch(dataPath)
      .then(result => {
        if (!jsonResponse.test(result.headers.get('Content-Type') || '')) {
          setFetchStatus(FetchStatus.Error)
          setError(
            `Content type invalid, ${result.headers.get('Content-Type')}`
          )
          return
        }

        if (!result.ok) {
          setFetchStatus(FetchStatus.Error)
          setError(`Result status not ok, ${result.status}`)
          return
        }

        result.json().then(
          fetchedData => {
            setData(fetchedData)
            setFetchStatus(FetchStatus.Complete)
            setError(undefined)
          },
          jsonError => {
            setFetchStatus(FetchStatus.Error)
            setError(`Json parse failed, ${jsonError}`)
          }
        )
      })
      .catch(fetchError => {
        setFetchStatus(FetchStatus.Error)
        setError(`Fetch error, ${fetchError}`)
      })
  }, [dataPath])
  return [data, fetchStatus, error]
}

export default fetchPageData
